import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { navItems } from './navItems'
import { useLanguage } from '@afsa/shared'

type Props = {
  isOpen: boolean
  openSubmenu: string | null
  setOpenSubmenu: (v: string | null) => void
  setIsOpen: (v: boolean) => void
}

export const MobileNav = ({
  isOpen,
  openSubmenu,
  setOpenSubmenu,
  setIsOpen
}: Props) => {
  const { t } = useLanguage()

  if (!isOpen) return null

  const toggle = (title: string) => {
    setOpenSubmenu(openSubmenu === title ? null : title)
  }

  return (
    <div className="lg:hidden absolute top-full left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg overflow-y-auto"
      style={{ maxHeight: 'calc(100vh - 3rem)' }}>

      <div className="px-4 py-6 space-y-6">

        <h3 className="text-base font-semibold text-gray-800 mb-4 font-satoshi">
          {t('navigation')}
        </h3>

        <ul className="space-y-1 list-none">
          {navItems.map((item, index) => (
            <li key={index}>

              {item.hasDropdown ? (
                <>
                  <button
                    onClick={() => toggle(item.title)}
                    className="w-full flex items-center justify-between px-4 py-3 text-gray-700 font-medium font-satoshi hover:bg-gray-50 rounded-lg"
                  >
                    <span>{item.title}</span>
                    <ChevronRight
                      className={`w-4 h-4 transition-transform ${
                        openSubmenu === item.title ? 'rotate-90' : ''
                      }`}
                    />
                  </button>

                  <div className={`pl-6 overflow-hidden transition-all ${
                    openSubmenu === item.title ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}>

                    {item.subItems?.map((sub, i) => (
                      <Link
                        key={i}
                        to={sub.href}
                        onClick={() => setIsOpen(false)}
                        className="block px-4 py-2 text-sm text-gray-600 hover:text-wine-100 rounded"
                      >
                        {sub.title}
                      </Link>
                    ))}

                  </div>
                </>
              ) : (
                <Link
                  to={item.href}
                  onClick={() => setIsOpen(false)}
                  className="block px-4 py-3 text-gray-700 font-medium font-satoshi hover:bg-gray-50 rounded-lg"
                >
                  {item.title}
                </Link>
              )}

            </li>
          ))}
        </ul>

      </div>
    </div>
  )
}